(() => {
  const {
    client, language, assetsBase, version,
  } = window.swinger.config;
  const url = `${assetsBase}/translations/translations.${client}.${language}.json?v=${version}`;
  const translations = new Promise((resolve) => {
    fetch(url, {
      method: 'GET',
      credentials: 'include',
      mode: 'no-cors',
    })
      .then((result) => result.text())
      .then((result) => window.swinger.json.parse(result))
      .then((result) => {
        resolve(result);
        window.swinger.webworker.twigWorker.postMessage({
          action: 'translationsResult',
          result,
        });
      })
      .catch((e) => {
        console.log('Fetching translations resulted in an error', e);
      });
  });

  const i18n = function i18n() {
    return translations.then((translations) => (key, context) => {
      let translation = translations[key] || key;

      if (context && typeof context === 'object') {
        Object.keys(context).forEach((variable) => {
          const value = context[variable];
          if (typeof value !== 'number' && typeof value !== 'string') {
            return;
          }

          translation = translation.split(`{${variable}}`).join(value);
        });
      }

      return translation;
    });
  };

  window.swinger = { ...window.swinger, i18n };
})();
